import React, { Component } from "react";
import { Form, Icon, Input, Button, Checkbox } from "antd";
const { Search } = Input;

const SearchBtn = (props) => {
  let { disabled, count, defaultName } = props;
  return (
    <Button style={{ width: "120px"}} type="primary">
      {disabled ? count : defaultName}
    </Button>
  );
};

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 3 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 21 },
  },
  labelAlign:'right'
};

class Register extends Component {
  state = {
    isSuccess: false,
    countLoading: false,
    count: 59,
    mngInfo:{
      userId:null
    }
  };
 
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      values.entAgentInfo = {
        agentNam: values.agentNam,
        agentMbl: values.agentMbl,
        agentEmail: values.agentEmail
      }
      values.roleInfos = this.state.roleInfos
      values.mngInfo = this.state.mngInfo
      console.log(values)
      if (!err) {
        function success(res){
          if(res&&res.head&&res.head.code==='0000'){
            // this.setState({
            //   isSuccess: true
            // })
            tool.popSingleUI('/')
            tool.popMessage(res.head.msg, "success")
          }else{
            tool.popMessage(res.head.msg, "error")
          }
        }
        let url = sgiConfig.service_cust + '/ent/register'
        commonClient.simplecall(url, values, success)
      }
    });
  };

  countDown = () => {
    let { count } = this.state;
    let timer = setInterval(() => {
      this.setState({ count: count-- }, () => {
        if (count <= -1) {
          clearInterval(timer);
          this.setState({
            count: 59,
            countLoading: false,
          });
        }
      });
    }, 1000);
  };
  // 验证手机号是否注册
  validatePhone = (loginNam, cb) => {
    let success = function (res) {
      if (res && res.body) {
        tool.popMessage("手机号已注册,请更换手机号！", 'error')
      } else {
        cb()
      }
    };
    let req = {
      loginNam
    }
    commonClient.simplecall(
      sgiConfig.service_uam + "/index/mbl",
      req,
      success
    );
  }
  beforeSendNote = () => {
    let { validateFields } = this.props.form
    validateFields(['agentMbl'],(err,value)=>{
      if(err) return 
      this.sendNote()
      // this.validatePhone(value.agentMbl, this.sendNote)
    })
  }
  sendNote = () => {
    let { getFieldValue } = this.props.form
    if (this.state.countLoading) return console.log('倒数中。。。。')
    let success = (res) => {
      if(res.head.code==='0000'){
        this.setState({
          countLoading: true,
        });
        if (!this.state.count == 0) {
          this.countDown()
        }
      }else{
        tool.popMessage(res.head.msg, "error");
      }
    };
    commonClient.simplecall(
      sgiConfig.allUrl.sendNoteByPhone,
      { linkmanMbl: getFieldValue('agentMbl') },
      success
    );
  };

  getCustByCode = (setFieldsValue,e) => {
    if(!e.target.value) return
    let success = (res) => {
      if (res && res.head && res.head.code === "0000") {
        setFieldsValue({'entNam':res.body.entNam})
        setFieldsValue({'socialCreditCode':res.body.socialCreditCode})
        setFieldsValue({'agentMbl':res.body.agentMbl||null})
        setFieldsValue({'email':res.body.email||null})
        this.setState({
          mngInfo:{
            userId:res.body.mngInfo.userId||null
          },
          roleInfos: res.body.roleInfos||[]
        });
      }else{
        tool.popMessage(res.head.msg, "error")
      }
    };
    let url =  sgiConfig.service_cust+'/supMan/getEntNam';
    console.log(url)
    commonClient.simplecall(url,{ inviteCode: e.target.value },success)
  }
  Change = (e) => {
    this.setState({
      [e.target.name] : e.target.value
    })
  }
  compareToFirstPassword = (rule, value, callback) => {
    const { form } = this.props;
    if (value && value !== form.getFieldValue('password')) {
      callback('密码输入不一致');
    } else {
      callback();
    }
  }
  toLogin = () => {
    tool.popSingleUI('/')
  }
  render() {
    const { getFieldDecorator, getFieldValue, setFieldsValue, validateFields } = this.props.form;
    let { isSuccess } = this.state
    return (
      !isSuccess
      ?<Form onSubmit={this.handleSubmit} {...formItemLayout} size="small">
        <Form.Item label="邀请码">
          {getFieldDecorator("inviteCode", {
            rules: [{ required: true, message: "请输入邀请码" }],
            // initialValue:'Q33W4N'
          })(
            <Input
              onBlur={(e)=>this.getCustByCode(setFieldsValue,e)}
              // prefix={<Icon type="user"  />}
              placeholder="邀请码"
              style={{maxWidth:'300px'}}
            />
          )}
        </Form.Item>
        <Form.Item label="企业名称">
          {getFieldDecorator("entNam", {
            rules: [{ required: true, message: "验证码校验错误" }],
          })(
            <Input
              // prefix={<Icon type="lock"  />}
              disabled
              placeholder="企业名称"
              style={{maxWidth:'300px'}}
            />
          )}
        </Form.Item>
        
        <Form.Item label="社会信用代码">
          {getFieldDecorator("socialCreditCode", {
            rules: [{ required: true, message: "请输入社会信用代码" }],
          })(
            <Input
              // prefix={<Icon type="lock"  />}
              disabled
              placeholder="社会信用代码"
              style={{maxWidth:'300px'}}
            />
          )}
        </Form.Item>
        <Form.Item label="企业编码">
          {getFieldDecorator("entCode", {
            rules: [{ required: true, message: "请输入企业编码" }],
          })(
            <Input
              // prefix={<Icon type="lock"  />}
              placeholder="企业编码"
              style={{maxWidth:'300px'}}
            />
          )}
        </Form.Item>
        {/* <Form.Item label="账号">
          {getFieldDecorator("loginId", {
            rules: [
              { required: true, message: "请输入账号" },
              { pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/, message: "账号只能由字母和数字组成" },
            ],
          })(
            <Input
              prefix={<Icon type="user"  />}
              placeholder="账号"
            />
          )}
        </Form.Item>
        <Form.Item label="密码">
          {getFieldDecorator("password", {
            rules: [
              { required: true, message: "请输入密码" },
              { pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/, message: "密码只能由字母和数字组成" },
            ],
          })(
            <Input
              prefix={<Icon type="lock"  />}
              placeholder="密码"
            />
          )}
        </Form.Item>
        <Form.Item label="再次输入密码" hasFeedback>
          {getFieldDecorator("surePassword", {
            rules: [
              { required: true, message: "请再次输入密码" },
              { validator: this.compareToFirstPassword, },
            ],
          })(
            <Input
              prefix={<Icon type="lock"  />}
              placeholder="请再次输入密码"
            />
          )}
        </Form.Item> */}
        <Form.Item label="用户名">
          {getFieldDecorator("userNam", {
            rules: [
              { required: true, message: "请设置用户名" },
              { min: 6, message: "用户名至少6位" },
            ],
          })(
            <Input
              // prefix={<Icon type="lock"  />}
              placeholder="请设用户名"
              style={{maxWidth:'300px'}}
            />
          )}
        </Form.Item>
        <Form.Item label="姓名">
          {getFieldDecorator("agentNam", {
            rules: [{ required: true, message: "请输入姓名" }],
          })(
            <Input
              // prefix={<Icon type="lock"  />}
              placeholder="姓名"
              style={{maxWidth:'300px'}}
            />
          )}
        </Form.Item>

        <Form.Item label="邮箱">
          {getFieldDecorator("agentEmail", {
            rules: [
              { required: true, message: "请输入邮箱" },
              {
                type: 'email',
                message: '邮箱格式不正确',
              },
            ],
          })(
            <Input
              // prefix={<Icon type="lock"  />}
              placeholder="邮箱"
              style={{maxWidth:'300px'}}
            />
          )}
        </Form.Item>

        <Form.Item label="手机号码">
          {getFieldDecorator("agentMbl", {
            rules: [
              { required: true, message: "请输入手机号码" },
              { pattern: /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/, message: "手机号码格式不对" },
            ],
          })(
            <Input
              // prefix={<Icon type="lock"  />}
              placeholder="手机号码"
              style={{maxWidth:'300px'}}
            />
          )}
        </Form.Item>

        <Form.Item label="短信验证码">
          {getFieldDecorator("code", {
            rules: [{ required: true, message: "短信验证码" }],
          })(
            <Search
              // prefix={<Icon type="lock"  />}
              placeholder="短信验证码"
              enterButton={SearchBtn({
                disabled: this.state.countLoading,
                count: this.state.count + " 秒",
                defaultName: "发送验证码",
              })}
              onSearch={()=>this.beforeSendNote()}
              style={{maxWidth:'300px'}}
            />
          )}
        </Form.Item>
        <Form.Item label=" " colon={false}>
          <Button style={{maxWidth:'300px',width:'100%'}} type="primary" htmlType="submit">
            注册
          </Button>
        </Form.Item>
      </Form>
      :<div style={{textAlign: 'center'}}>
        <span style={{color:'#67C23A',fontSize:'30px'}}>
          <Icon type="check"/>
          注册成功
        </span>
        <Button onClick={this.toLogin} type="link" block>去登录</Button>
      </div>
    );
  }
}

const RegisterForm = Form.create()(Register);
export default RegisterForm;



// WEBPACK FOOTER //
// ./apps/pages/register/RegisterForm.js